import { useEffect } from 'react';
import { useTutorialWithNavigation } from '../hooks/useTutorial';
import { useTutorialContext } from '../context/TutorialContext';
import { TutorialStep } from './TutorialTooltip';

const tutorialSteps: TutorialStep[] = [
  {
    id: "createSalesPage",
    question_text: "Crear página de ventas",
    description: "Inicia dándole clic al botón para empezar a crear tu primera página de ventas de manera guiada.",
    type: "action",
    options: null,
    next_step: "chooseOption",
    required: true,
    is_summary: false,
    survey_id: "default",
    is_first_step: true
  },
  {
    id: "chooseOption",
    question_text: "Elige cómo empezar",
    description: "Tendrás 3 opciones diferentes para cargar tu producto ganador.",
    type: "action",
    options: null,
    next_step: "orderBump",
    required: true,
    is_summary: false,
    survey_id: "default",
    is_first_step: false
  },
  {
    id: "orderBump",
    question_text: "Order Bump",
    description: "Es una oferta rápida en el checkout. Perfecto para artículos pequeños o complementarios.",
    type: "action",
    options: null,
    next_step: "salesAngles",
    required: true,
    is_summary: false,
    survey_id: "default",
    is_first_step: false
  },
  {
    id: "salesAngles",
    question_text: "Ángulos de venta",
    description: "Selecciona el enfoque de marketing ideal para vender tu producto. Identificamos los dolores más importantes de tu usuario final, para generar el contenido persuasivo de toda tu página de ventas y maximizar tus conversiones.",
    type: "action",
    options: null,
    next_step: null,
    required: true,
    is_summary: false,
    survey_id: "default",
    is_first_step: false
  }
];

export function TutorialSetup() {
  useTutorialWithNavigation();
  const { setSteps } = useTutorialContext();

  useEffect(() => {
    setSteps(tutorialSteps);
  }, [setSteps]);

  return null;
}
